module.exports = __webpack_public_path__ + "static/media/PRACTICA5.cd212699.jpg";